// src/components/Admin/Settings/Notification_Setting/NotificationTemplateDialog.jsx
import React, { useEffect, useState } from "react";
import { X, MessageCircle, Smartphone, Mail, Save, Bell } from "lucide-react";

export default function NotificationTemplateDialog({
  type = "sms",
  title = "Notification",
  message = "",
  fields = [],
  record,
  onClose,
  onSubmit,
}) {
  const [values, setValues] = useState({});

  useEffect(() => {
    const initial = {};
    fields.forEach((f) => {
      if (record && record[f.name] != null) {
        initial[f.name] = record[f.name];
      } else if (f.selected != null) {
        initial[f.name] = f.selected;
      } else {
        initial[f.name] = "";
      }
    });
    setValues(initial);
  }, [fields, record]);

  const handleChange = (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(values);
    else onClose();
  };

  const renderIcon = () => {
    if (type === "whatsapp") {
      return <MessageCircle className="w-5 h-5 text-white" />;
    }
    if (type === "sms") {
      return <Smartphone className="w-5 h-5 text-white" />;
    }
    if (type === "email") {
      return <Mail className="w-5 h-5 text-white" />;
    }
    return <Bell className="w-5 h-5 text-white" />;
  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg overflow-hidden">
        {/* Header - Teal themed */}
        <div className="bg-gradient-to-r from-teal-600 to-teal-700 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white/20 rounded-lg">
              {renderIcon()}
            </div>
            <div>
              <h2 className="text-lg font-bold text-white">{title}</h2>
              {message && (
                <p className="text-xs text-teal-100">{message}</p>
              )}
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/20 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-white" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit}>
          <div className="px-6 py-5 space-y-4">
            {fields.map((field) => (
              <div key={field.name}>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  {field.label}
                </label>

                {field.type === "input" && (
                  <input
                    type="text"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    placeholder={field.placeholder || ""}
                    value={values[field.name] ?? ""}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                  />
                )}

                {field.type === "select" && (
                  <select
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    value={values[field.name] ?? ""}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                  >
                    <option value="">Select</option>
                    {(field.options || []).map((opt) => (
                      <option key={opt.key} value={opt.key}>
                        {opt.value}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2.5 bg-white border border-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 hover:border-gray-300 transition-all"
            >
              Close
            </button>
            {onSubmit && (
              <button
                type="submit"
                className="px-5 py-2.5 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 transition-all flex items-center gap-2"
              >
                <Save className="w-4 h-4" />
                Save
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
